import {
  CarrierType,
  CreateInternalWorkInstructionCommand,
  WorkInstructionsApi,
} from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class WorkInstructionService {
  httpClient = createApiClient(WorkInstructionsApi)

  createInternalWorkInstruction = async (
    createInternalWorkInstructionCommand: CreateInternalWorkInstructionCommand,
  ) => {
    await this.httpClient.createInternalWorkInstruction(createInternalWorkInstructionCommand)
  }

  getControlRoomWorkInstructions = async (
    visitIds: number[],
    carrierType?: CarrierType,
    workInstructionIds?: number[],
  ) => {
    const { data } = await this.httpClient.getWorkInstructionsForControlRoom(
      visitIds,
      workInstructionIds,
      carrierType,
    )

    return data
  }
  getWorkInstructionByExternalOrderId = async (id: number) => {
    const { data } = await this.httpClient.getWorkInstructionByExternalOrderId(id)
    return data
  }

  getTotalNumbers = async () => {
    const { data } = await this.httpClient.getTotalNumbers()
    return data
  }

  start = async (ids: number[]) => {
    await this.httpClient.start({ ids })
  }

  stop = async (ids: number[]) => {
    await this.httpClient.stop({ ids })
  }

  setPriority = async (ids: number[], isPriority: boolean) => {
    await this.httpClient.setPriority({ ids, isPriority })
  }

  getGeneralCargoCompletedAmountById = async (id: number) => {
    const { data } = await this.httpClient.getGeneralCargoCompletedAmountById(id)
    return data
  }
}

const workInstructionService = new WorkInstructionService()

export default workInstructionService
